/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpDiskSnapshotProperties } from '../models/GcpDiskSnapshotProperties';

/**
* Properties of the original GCP Virtual Machine instance at the time the snapshot was taken. Present only when `resourceType` is set to `GCP_VM_INSTANCE`. 
*/
export class GcpVmSnapshotProperties {
  /**
  * The name of the resource
  */
  'name'?: string;
  /**
  * The region of the virtual machine
  */
  'region'?: string;
  /**
  * The machine type of the virtual machine
  */
  'machineType'?: string;
  /**
  * The network of the virtual machine
  */
  'network'?: string;
  /**
  * The metadata of the virtual machine
  */
  'metadata'?: { [key: string]: string; };
  'disks'?: Array<GcpDiskSnapshotProperties>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "machineType",
      "baseName": "machineType",
      "type": "string",
      "format": ""
    },
    {
      "name": "network",
      "baseName": "network",
      "type": "string",
      "format": ""
    },
    {
      "name": "metadata",
      "baseName": "metadata",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "disks",
      "baseName": "disks",
      "type": "Array<GcpDiskSnapshotProperties>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpVmSnapshotProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

